/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faUnlock } from '@fortawesome/free-solid-svg-icons';
import { useQuoteAwnings } from '../Store/entities/awnings/hooks';
import PSAwningTableRow from './PSAwningTableRow';
import Table from '../Parts/Table';
import { useQuoteById, useQuoteTypeNameByQuoteId } from '../Store/entities/quotes/hooks';
import { useCurrentMultiplier } from '../Store/entities/multipliers/hooks';
import { useIsPsAdmin } from '../hooks';
import { UsePortalDispatch } from '../Store';
import { setAwningsUnlocked } from '../Store/entities/awnings';
import type { AwningFabric, AwningProperty } from './awningTypes';
import type { fakeRootType } from '../FakeRootType';

type PSAwningsProps = {
	quoteId: number;
	ROOT: fakeRootType;
	unlockQuoteForEditing: () => void;
	awningProperties: AwningProperty[];
	awningFabrics: AwningFabric[];
};

const PSAwningsTable = ({
	quoteId,
	ROOT,
	unlockQuoteForEditing,
	awningProperties,
	awningFabrics,
}: PSAwningsProps) => {
	const dispatch = UsePortalDispatch();
	const quoteAwnings = useQuoteAwnings(quoteId);
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);
	const multiplier = useCurrentMultiplier(quoteId);
	const isEditable = useQuoteById(quoteId)?.editable ?? false;
	const isPsAdmin = useIsPsAdmin();

	if (quoteAwnings.length === 0) {
		return null;
	}

	const isAllAwningsUnlocked = quoteAwnings.every((awning) => awning.unlocked);
	const unlockAllAwnings = () => {
		dispatch(setAwningsUnlocked({
			quoteId,
			lineNumbers: quoteAwnings.map((awning) => awning.line_number),
			unlocked: true,
		}));
	};

	const columns = [
		'Unlock/Select',
		'Room Name',
		'Shade Name',
		'Fabric',
		'Width',
		'Projection',
		'Frame Color',
		'Mounting',
		`${multiplier.label} (${multiplier.currency})`,
		...(isPsAdmin ? ['Shipping'] : []),
		'Actions',
	];

	return (
		<div
			className="quote-table"
			style={{ overflowX: 'auto', overflowY: 'hidden', marginBottom: '2em' }}
		>
			<Table
				className="awnings-table quote-rows-table-indoor"
				quoteType={quoteType}
				noTBody
				style={{ width: '100%', zIndex: '20' }}
			>
				<tbody style={{ zIndex: 900 }}>
					<tr className="bold-row">
						<th className={quoteType} colSpan={1}>
							<div style={{ textAlign: 'center' }}>
								{isEditable && (
									<span
										title="unlock all awnings"
										onClick={() => (!isAllAwningsUnlocked && unlockAllAwnings())}
										className="fa-fw"
										style={{ cursor: 'pointer' }}
									>
										<FontAwesomeIcon
											className="icon-unlock unlock-all"
											transform="x-12 grow-6"
											icon={isAllAwningsUnlocked ? faUnlock : faLock}
										/>
									</span>
								)}
							</div>
						</th>
						<th className={quoteType} colSpan={columns.length - 1}>
							<div className={`table-header ${quoteType}`} style={{ textAlign: 'center' }}>
								Awnings
							</div>
						</th>
					</tr>
					<tr>
						{columns.map((column) => (
							<th key={column}>{column}</th>
						))}
					</tr>
					{quoteAwnings.map((awning) => (
						<PSAwningTableRow
							key={awning.line_number}
							quoteId={quoteId}
							lineNumber={awning.line_number}
							ROOT={ROOT}
							unlockQuoteForEditing={unlockQuoteForEditing}
							awningProperties={awningProperties}
							awningFabrics={awningFabrics}
						/>
					))}
				</tbody>
			</Table>
		</div>
	);
};

export default PSAwningsTable;
